const config = {
    apiBaseUrl: 'https://muserendipia.com/gate'
};

export default config;